import { faMusic } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type React from "react";
import { useEffect } from "react";
import Slider from "./Slider";

interface TopBarProps {
  spriteSize: number;
  setSpriteSize: (size: number) => void;
  hidePokeballs: boolean;
  setHidePokeballs: (hide: boolean) => void;
  showRed: boolean;
  setShowRed: (show: boolean) => void;
  revealAllPokemon: boolean;
  setRevealAllPokemon: (reveal: boolean) => void;
}

function TopBar({
  spriteSize,
  setSpriteSize,
  hidePokeballs,
  setHidePokeballs,
  showRed,
  setShowRed,
  revealAllPokemon,
  setRevealAllPokemon,
}: TopBarProps): React.JSX.Element {
  // Set global sprite size CSS variable for trainer animations
  useEffect(() => {
    document.documentElement.style.setProperty("--sprite-size", `${spriteSize}px`);
  }, [spriteSize]);

  return (
    <header className="header">
      <div className="flex items-center gap-2">
        <h1 className="header-title">
          <FontAwesomeIcon icon={faMusic} className="text-primary" /> Pokémon Karaoke
        </h1>
      </div>

      <div className="header-controls">
        <label className="label">
          <input
            type="checkbox"
            checked={hidePokeballs}
            onChange={(e) => setHidePokeballs(e.target.checked)}
            className="checkbox"
          />
          <span>Open Pokeballs</span>
        </label>
        
        <label className="label">
          <input
            type="checkbox"
            checked={revealAllPokemon}
            onChange={(e) => setRevealAllPokemon(e.target.checked)}
            className="checkbox"
          />
          <span>One for All</span>
        </label>
        
        <label className="label">
          <div className="flex items-center gap-1">
            <img src="/trainers/leaf standing.png" alt="Leaf" className="w-8 h-8 pixelated" />
            <div 
              className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus-within:ring-2 focus-within:ring-primary focus-within:ring-offset-2 focus-within:ring-offset-bg-primary ${
                showRed ? 'bg-orange-600' : 'bg-green-600'
              }`}
            >
              <input
                type="checkbox"
                checked={showRed}
                onChange={(e) => setShowRed(e.target.checked)}
                className="sr-only"
              />
              <span
                className={`${
                  showRed ? 'translate-x-6 bg-orange-200' : 'translate-x-1 bg-white'
                } inline-block h-4 w-4 transform rounded-full transition-transform`}
              />
            </div>
            <img src="/trainers/red standing.png" alt="Red" className="w-8 h-8 pixelated" />
          </div>
        </label>
        
        <Slider
          value={spriteSize}
          onChange={setSpriteSize}
          min={32}
          max={128}
          step={8}
          label="Size"
          showValue={true}
          valueFormatter={(val) => `${val}px`}
          className="w-20 mx-2"
        />
      </div>
    </header>
  );
}

export default TopBar;
